new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#app_list',
  data: {
    menuFilter: false,
    listOpened: false,
    listEx: localStorage.getItem('listOrder') ? localStorage.getItem('listOrder') : localStorage.setItem('listOrder', 0),
    listExMobile: localStorage.getItem('listOrderMobile') ? localStorage.getItem('listOrderMobile') : localStorage.setItem('listOrderMobile', 0)
  },
  methods: {
    buySize() {
      const filterSize = document.querySelector(".product-list__filters .product-filter__item--size");
      const elementDest = document.querySelector("#buy-sizes");
      if (filterSize && elementDest) {
        const cloneFilterSize = filterSize.cloneNode(true);
        elementDest.append(cloneFilterSize);
        const listSize = document.querySelector(".product-list-size");
        if (listSize) {
          const buySizesWidth = elementDest.offsetWidth;
          listSize.style.minWidth = `${buySizesWidth + 1}px`;
          listSize.style.width = `auto`;
        }
      } else {
        const listSize = document.querySelector(".product-list-size");
        if (listSize) {
          listSize.style.display = "none";
        }
      }
    },
    filterPrice() {
      //chamadas para o filtro de preço
      function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
        const [from, to] = getParsed(fromInput, toInput);
        fillSlider(fromInput, toInput, '#E9E9E9', '#393B46', controlSlider);
        if (from > to) {
          fromSlider.value = to;
          fromInput.value = to;
        } else {
          fromSlider.value = from;
        }
      }

      function controlToInput(toSlider, fromInput, toInput, controlSlider) {
        const [from, to] = getParsed(fromInput, toInput);
        fillSlider(fromInput, toInput, '#E9E9E9', '#393B46', controlSlider);
        setToggleAccessible(toInput);
        if (from <= to) {
          toSlider.value = to;
          toInput.value = to;
        } else {
          toInput.value = from;
        }
      }

      function controlFromSlider(fromSlider, toSlider, fromInput) {
        const [from, to] = getParsed(fromSlider, toSlider);
        fillSlider(fromSlider, toSlider, '#E9E9E9', '#393B46', toSlider);
        if (from > to) {
          fromSlider.value = to;
          fromInput.value = to;
        } else {
          fromInput.value = from;
        }
      }

      function controlToSlider(fromSlider, toSlider, toInput) {
        const [from, to] = getParsed(fromSlider, toSlider);
        fillSlider(fromSlider, toSlider, '#E9E9E9', '#393B46', toSlider);
        setToggleAccessible(toSlider);
        if (from <= to) {
          toSlider.value = to;
          toInput.value = to;
        } else {
          toInput.value = from;
          toSlider.value = from;
        }
      }

      function getParsed(currentFrom, currentTo) {
        const from = parseInt(currentFrom.value, 10);
        const to = parseInt(currentTo.value, 10);
        return [from, to];
      }

      function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
        const rangeDistance = to.max - to.min;
        const fromPosition = from.value - to.min;
        const toPosition = to.value - to.min;
        controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition) / (rangeDistance) * 100}%,
      ${rangeColor} ${((fromPosition) / (rangeDistance)) * 100}%,
      ${rangeColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} 100%)`;
      }

      function setToggleAccessible(currentTarget) {
        const toSlider = document.querySelector('#toSlider');
        if (Number(currentTarget.value) <= 0) {
          toSlider.style.zIndex = 2;
        } else {
          toSlider.style.zIndex = 0;
        }
      }

      const fromSlider = document.querySelector('#fromSlider');
      const toSlider = document.querySelector('#toSlider');
      const fromInput = document.querySelector('#fromInput');
      const toInput = document.querySelector('#toInput');
      let url = window.location.href;

      if (url.includes('?lp=')) {
        const params = new URLSearchParams(window.location.search)
        const firstParams = params.get('lp');
        const secondParams = params.get('hp');
        fromInput.value = firstParams;
        toInput.value = secondParams;
        fromSlider.setAttribute('value', firstParams);
        toSlider.setAttribute('value', secondParams);
        fillSlider(fromSlider, toSlider, '#E9E9E9', '#393B46', toSlider);
      } else {
        fillSlider(fromSlider, toSlider, '#E9E9E9', '#393B46', toSlider);
        setToggleAccessible(toSlider);
      }

      fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput);
      toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput);
      fromInput.oninput = () => controlFromInput(fromSlider, fromInput, toInput, toSlider);
      toInput.oninput = () => controlToInput(toSlider, fromInput, toInput, toSlider);

      function handleSliderRelease() {
        let from = $('#fromInput').val();
        let to = $('#toInput').val();
        window.location = `?lp=${from}&hp=${to}`;
      }

      $(fromSlider).mouseup(handleSliderRelease);
      $(fromSlider).on('touchend', handleSliderRelease);

      $(toSlider).mouseup(handleSliderRelease);
      $(toSlider).on('touchend', handleSliderRelease);
    },
    changeList(list) {
      this.listEx = list;
      localStorage.setItem('listOrder', list);
    },

    changeListMobile(list) {
      this.listExMobile = list;
      this.listOpened = false;
      localStorage.setItem('listOrderMobile', list);
    }
  },
  mounted() {
    this.filterPrice();
    this.buySize()

    var selectOrdenar = document.querySelector('.selectskin')
    if (selectOrdenar) {
        var primeiroOption = selectOrdenar.querySelector('option:first-child')
        if (primeiroOption && primeiroOption.textContent.includes("Ordenar por")) {
            primeiroOption.textContent = primeiroOption.textContent.replace("Ordenar por", "Ordenar")
        }
    }

    // Implementação do acordeão para filtros
    const filterItems = document.querySelectorAll('.product-filter__item__title');
    filterItems.forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        const parent = this.closest('.product-filter__item');
        const submenu = parent.querySelector('.product-filter__sub-menu');

        // Toggle active class no item
        parent.classList.toggle('active');

        // Slide toggle no submenu
        if (parent.classList.contains('active')) {
          submenu.style.maxHeight = submenu.scrollHeight + 'px';
        } else {
          submenu.style.maxHeight = '0';
        }
      });
    });

    // Abrir o primeiro filtro por padrão
    const firstFilterItem = document.querySelector('.product-filter__item');
    if (firstFilterItem) {
      firstFilterItem.classList.add('active');
      const firstSubmenu = firstFilterItem.querySelector('.product-filter__sub-menu');
      if (firstSubmenu) {
        firstSubmenu.style.maxHeight = firstSubmenu.scrollHeight + 'px';
      }
    }

    // Toggle descrição da categoria (com animação suave de abrir/fechar)
    const openDescBtn = document.querySelector('.open-description');
    const descriptionCategory = document.querySelector('.description-category');
    if (openDescBtn && descriptionCategory) {
      const labelOpen  = 'Ver descrição completa';
      const labelClose = 'Fechar descrição';
      const desc = descriptionCategory.querySelector('.categry-description');

      openDescBtn.addEventListener('click', function () {
        const isActive = descriptionCategory.classList.toggle('active');
        openDescBtn.textContent = isActive ? labelClose : labelOpen;

        if (!desc) return;

        if (isActive) {
          // Abrir: tira o clamp e anima de 1 linha até a altura total
          desc.classList.remove('is-clamped');
          desc.style.maxHeight = desc.scrollHeight + 'px';
          desc.addEventListener('transitionend', function te(e) {
            if (e.propertyName !== 'max-height') return;
            desc.style.maxHeight = 'none'; // libera p/ reflow/responsivo depois de aberto
            desc.removeEventListener('transitionend', te);
          });
        } else {
          // Fechar: fixa a altura atual, força reflow e anima de volta p/ 1 linha
          desc.style.maxHeight = desc.scrollHeight + 'px';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              desc.style.maxHeight = ''; // volta ao valor do CSS (1 linha)
            });
          });
          desc.addEventListener('transitionend', function te(e) {
            if (e.propertyName !== 'max-height') return;
            desc.classList.add('is-clamped'); // reaplica clamp/reticências no fim
            desc.removeEventListener('transitionend', te);
          });
        }
      });
    }

    // Toggle do "sobre" da categoria. O texto vem do painel e pode ser tanto
    // texto puro quanto HTML do cliente (container/col-*/h2/p...), então o
    // corte fechado é feito por altura e só cai no line-clamp de 1 linha
    // quando o conteúdo é realmente texto puro.
    document.querySelectorAll('.description-about').forEach(function (aboutDescription) {
      const openAbout = aboutDescription.querySelector('.open-about');
      const desc = aboutDescription.querySelector('.about-description');
      if (!openAbout || !desc) return;

      const labelOpen  = 'Ver mais';
      const labelClose = 'Fechar descrição';

      const isRich = !!desc.querySelector('p, div, section, article, ul, ol, table, h1, h2, h3, h4, h5, h6, br, img');
      desc.classList.add(isRich ? 'is-rich' : 'is-plain');
      desc.classList.add('is-clamped');

      // sem conteúdo excedente não faz sentido mostrar o "ver mais"
      if (desc.scrollHeight <= desc.clientHeight + 1) {
        desc.classList.remove('is-clamped');
        openAbout.style.display = 'none';
        return;
      }

      if (!isRich) desc.classList.add('is-ellipsis');
      openAbout.textContent = labelOpen;

      openAbout.addEventListener('click', function () {
        const isActive = aboutDescription.classList.toggle('active');
        openAbout.textContent = isActive ? labelClose : labelOpen;

        if (isActive) {
          // Abrir: fixa a altura total inline (vence o clamp do CSS) e só
          // então tira as classes de corte, p/ a transição sair do fechado
          desc.style.maxHeight = desc.scrollHeight + 'px';
          desc.classList.remove('is-clamped');
          desc.classList.remove('is-ellipsis');
          desc.addEventListener('transitionend', function te(e) {
            if (e.propertyName !== 'max-height') return;
            desc.style.maxHeight = 'none'; // libera p/ reflow/responsivo depois de aberto
            desc.removeEventListener('transitionend', te);
          });
        } else {
          // Fechar: fixa a altura atual, força reflow e anima de volta
          desc.style.maxHeight = desc.scrollHeight + 'px';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              desc.classList.add('is-clamped');
              desc.style.maxHeight = ''; // volta ao valor do CSS (estado fechado)
            });
          });
          desc.addEventListener('transitionend', function te(e) {
            if (e.propertyName !== 'max-height') return;
            if (!isRich) desc.classList.add('is-ellipsis'); // reticências no fim
            desc.removeEventListener('transitionend', te);
          });
        }
      });
    });
  },
});